import { gameState } from "appworks/model/game-state";
import { wrapperImplementation } from "gameiom/wrapper/wrapper-implementation";
import { GameOverState } from "slotworks/state-machine/standard/states/game-over-state";

export class GameiomGameOverState extends GameOverState {
    public complete(): void {
        wrapperImplementation.onResume.addOnce(() => super.complete());
        gameWrapper.balancesUpdate(
            gameState.getCurrentGame().realBalance,
            gameState.getCurrentGame().freeBalance
        );
        gameWrapper.setIdle();
    }
}
